import React, { Fragment } from 'react';

export default {
  units: [
    {
      id: 'B8',
      mockup: (
        <g id="b8" transform="translate(258.000000, 180.000000)">
          <polygon
            id="fill-b8"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="123.537547 16.9774728 120.959883 16.9774728 87.1638466 16.9774728 87.1638466 0.652268683 0.955312547 0.652268683 0.955312547 73.3996695 31.6008711 73.3996695 31.6008711 71.6812269 94.896838 71.6812269 94.896838 51.6327307 123.537547 51.6327307"
          />
          <text
            id="02"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="42.604" y="33.0259691">
              02
            </tspan>
          </text>
          <text
            id="B8"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="41.824" y="49.0259691">
              B8
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'C1b',
      mockup: (
        <g id="c1b" transform="translate(199.000000, 180.000000)">
          <polygon
            id="fill-c1b"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="112.940624 92.0161303 80.0038088 92.0161303 80.0038088 73.3996695 59.9553125 73.3996695 59.9553125 0.652268683 22.1495767 0.652268683 0.669044975 154.739283 0.669044975 155.312097 112.940624 155.312097"
          />
          <text
            id="01"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="44.5447637" y="104.093724">
              01
            </tspan>
          </text>
          <text
            id="C1b"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="40.6567637" y="120.093724">
              C1b
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'C3',
      mockup: (
        <g id="c3" transform="translate(370.000000, 189.000000)">
          <polygon
            id="fill-c3"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="82.5665052 0.530888464 8.95988314 0.530888464 8.95988314 7.9774728 11.5375469 7.9774728 11.5375469 42.6327307 0.940484627 42.6327307 0.940484627 62.6812269 22.4210164 62.6812269 22.4210164 151.467425 98.6053022 151.467425"
          />
          <text
            id="03"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="52.3259026" y="74.5913693">
              03
            </tspan>
          </text>
          <text
            id="C3"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="51.7559026" y="90.5913693">
              C3
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'C7',
      mockup: (
        <g id="c7" transform="translate(384.000000, 340.000000)">
          <polygon
            id="fill-c7"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="84.6053022 0.467424747 8.42101636 0.467424747 8.42101636 25.6712486 6.98898091 25.6712486 6.98898091 50.0158513 0.115210754 50.0158513 0.115210754 139.374863 65.9888414 139.374863 88.3285944 35.6954968"
          />
          <text
            id="04"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="37.8259026" y="60.454383">
              04
            </tspan>
          </text>
          <text
            id="C7"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="37.2559026" y="76.454383">
              C7
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B9',
      mockup: (
        <g id="b9" transform="translate(295.000000, 390.000000)">
          <polygon
            id="fill-b9"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="89.1152108 0.0158512682 54.4599529 0.0158512682 54.4599529 9.46728523 26.3920581 9.46728523 26.3920581 0.0158512682 14.6493674 0.0158512682 0.0426058515 0.0158512682 0.0426058515 75.0545088 1.76104839 75.0545088 37.2755275 75.0545088 37.2755275 89.3748633 89.1152108 89.3748633"
          />
          <text
            id="05"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="39.8536163" y="33.496383">
              05
            </tspan>
          </text>
          <text
            id="B9"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="39.0736163" y="49.496383">
              B9
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'D1',
      mockup: (
        <g id="d1" transform="translate(199.000000, 335.000000)">
          <polygon
            id="fill-d1"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="96.0426059 55.0158513 110.649367 55.0158513 110.649367 50.4333378 110.649367 36.1129833 112.940624 36.1129833 112.940624 0.312097132 0.669044975 0.312097132 21.5767625 150.103005 97.7610484 150.103005 97.7610484 130.054509 96.0426059 130.054509"
          />
          <text
            id="06"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="44.5447637" y="60.4672852">
              06
            </tspan>
          </text>
          <text
            id="D1"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="43.7467637" y="76.4672852">
              D1
            </tspan>
          </text>
        </g>
      ),
    },
  ],
  outline: (
    <Fragment>
      <text
        id="LEVEL-19"
        fontFamily="DINCanfor-Medium, DIN Canfor"
        fontSize="16"
        fontWeight="400"
        fill="#0B1A27"
      >
        <tspan x="299.708" y="597.839844">
          LEVEL 19
        </tspan>
      </text>
      <g
        id="bg-shapes"
        transform="translate(193.000000, 163.000000)"
        stroke="#0B1A27"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      >
        <rect
          id="Rectangle-path"
          x="150.731811"
          y="109.01613"
          width="26.3494523"
          height="99.096853"
        />
        <path d="M150.731811,141.093724 L177.081263,141.093724" id="Shape" />
        <path d="M150.731811,174.889761 L177.081263,174.889761" id="Shape" />
        <path d="M135.552235,186.059637 L135.552235,132.787919" id="Shape" />
        <polyline
          id="Shape"
          points="119.227031 186.059637 135.552235 186.059637 150.731811 186.059637"
        />
        <polyline
          id="Shape"
          points="119.227031 132.787919 135.552235 132.787919 150.731811 132.787919"
        />
        <polyline
          id="Shape"
          points="150.731811 208.112983 177.081263 174.889761 150.731811 141.093724 177.081263 109.01613"
        />
        <polyline
          id="Shape"
          points="177.081263 208.112983 150.731811 174.889761 177.081263 141.093724 150.731811 109.01613"
        />
        <polyline
          id="Shape"
          points="150.731811 109.01613 118.940624 109.01613 118.940624 208.112983 150.731811 208.112983"
        />
        <path d="M128.392058,227.015851 L156.459953,227.015851" id="Shape" />
        <path d="M159.896838,88.6812269 L177.940485,88.6812269" id="Shape" />
        <path d="M96.6008711,90.3996695 L96.6008711,109.01613" id="Shape" />
        <polyline
          id="Shape"
          points="132.974572 109.01613 86.0038088 109.01613 86.0038088 90.3996695 96.6008711 90.3996695 96.6008711 88.6812269 159.896838 88.6812269 159.896838 68.6327307 177.940485 68.6327307 177.940485 88.6812269 199.421016 88.6812269 199.421016 202.671249 197.988981 202.671249 197.988981 227.015851 156.459953 227.015851 156.459953 236.467285 128.392058 236.467285 128.392058 227.015851 116.649367 227.015851 116.649367 208.112983 118.940624 208.112983"
        />
        <path d="M275.605302,177.467425 L294.794577,177.467425" id="Shape" />
        <polyline
          id="Shape"
          points="272.454824 147.967495 294.794577 147.967495 294.794577 248.496383 271.595603 248.496383"
        />
        <polyline
          id="Shape"
          points="101.756199 322.103005 101.756199 340.146652 191.25 340.146652 191.25 316.374863"
        />
        <polyline
          id="Shape"
          points="24.7744112 113.885051 0.216796875 113.885051 0.216796875 340.146652 101.603516 340.146652"
        />
        <polyline
          id="Shape"
          points="150.158997 17.6522687 150.158997 0.18143621 187.964733 0.18143621 187.964733 26.5308885"
        />
      </g>
      <g
        id="compass"
        transform="translate(563.051950, 473.966278)"
        fill="#0B1A27"
        fillRule="nonzero"
      >
        <polygon
          id="Shape"
          points="10.332078 38.8487477 3.78150781 29.9369255 3.78150781 38.8487477 0.848985112 38.8487477 0.848985112 25.1382519 3.85767723 25.1382519 10.2178239 33.7834812 10.2178239 25.1382519 13.1503466 25.1382519 13.1503466 38.8487477"
        />
        <polygon
          id="Shape"
          points="11.8935511 13.0653988 7.01870819 4.26783067 2.10578055 13.0653988 0.468138008 12.113281 7.01870819 0.345105502 13.5311937 12.113281"
        />
        <rect
          id="Rectangle-path"
          x="6.06659043"
          y="2.32551044"
          width="1.90423552"
          height="21.1370143"
        />
      </g>
    </Fragment>
  ),
};



// WEBPACK FOOTER //
// ./src/data/floorplates/svg/level19.js